import { type FC } from "react";

import { nameByPlatform } from "~/constants/platfroms";
import { CONSENSUS_CHIP_SUFFIX } from "~/feature/chart/components/MarketsDropdown/constants";
import { colorByPlatform } from "~/feature/chart/constants";
import type { Platform } from "~/types/platform";

import * as Styled from "./MarketChip.styles";

interface IMarketChipProps {
  title: string;
  platform?: Platform;
  isWholeMarket?: boolean;
  onRemove?: () => void;
}

export const MarketChip: FC<IMarketChipProps> = ({
  title,
  platform,
  isWholeMarket = false,
  onRemove,
}) => {
  return (
    <Styled.Root $whole={isWholeMarket}>
      {platform && !isWholeMarket && (
        <Styled.Dot $color={colorByPlatform[platform]} />
      )}

      <Styled.Label>
        <Styled.Title $whole={isWholeMarket} title={title}>
          {title}
        </Styled.Title>

        {isWholeMarket ? (
          <Styled.SuffixBadge>{CONSENSUS_CHIP_SUFFIX}</Styled.SuffixBadge>
        ) : (
          platform && (
            <Styled.Suffix>&nbsp;- {nameByPlatform[platform]}</Styled.Suffix>
          )
        )}
      </Styled.Label>

      {onRemove && (
        <Styled.RemoveButton
          size="small"
          aria-label={
            platform && !isWholeMarket
              ? `Remove ${title} - ${nameByPlatform[platform]}`
              : `Remove all ${title}`
          }
          onClick={onRemove}
        >
          <Styled.RemoveIcon />
        </Styled.RemoveButton>
      )}
    </Styled.Root>
  );
};
